<script lang="ts">
    import {setRpcMode, getServerUrl, rpcCall} from "../api/rpc";
    import {onMount} from "svelte";
    import Textfield from "@smui/textfield";
    import Button from "@smui/button";
    import {snack} from "../api/snack";

    let serverUrl = ''
    let email = ''

    const handleChangeMode = (mode: number) => {
        setRpcMode(mode)
        serverUrl = getServerUrl()
    }

    const grantAccess = async () => {
        try {
            let res = await rpcCall('giveRole', email, 1)
            console.log(res)
            snack('Access granted')
        } catch (e) {
            console.log(e)
            switch (e) {
                case 3:
                    snack('User does not exist')
                    break
                case 4:
                    snack('User already has access')
                    break
                default:
                    snack('Error granting access: ' + e)
                    break
            }
        }
    }

    const hackUser = async () => {
        try {
            await rpcCall('auth.admin', email);
            window.localStorage.setItem('userId', email);
            window.location = '/';
        } catch (e) {
            console.log(e)
            snack('Hack failed')
        }
    }

    onMount(() => {
        serverUrl = getServerUrl()
    })
</script>

<div style="padding: 24px">
    <p>Server url: {serverUrl}</p>
    <button on:click={() => handleChangeMode(1)}>1</button><br/>
    <button on:click={() => handleChangeMode(2)}>2</button><br/>
    <button on:click={() => handleChangeMode(3)}>3</button><br/>
    <br/>
    <Textfield type="email" bind:value={email} label="Email"/>
    <Button on:click={grantAccess}>Grant access</Button>
    <Button on:click={hackUser}>Hack user</Button>
</div>